







































































































































import { Component, Ref, Vue } from "vue-property-decorator";
import DateRangeSelector from "@/components/inputs/DateRangeSelector.vue";
import { EventType, EventStatus } from "@/models/event";
import EventDetail from "@/components/EventDetail/index.vue";
import EventsTableCard from "@/components/EventsTableCard.vue";
import { EventTypeIcon, EventTypeSelectionCard } from "@/components/EventType";
import { auth as authStore } from "@/store/modules";
import { inject } from "inversify-props";
import { EventExportFilter, IStatService, ICenterService, IAuthService } from "@/interfaces/Services";
import { DateInput } from '@/components/inputs';
import DependencyIdentifiers from '@/ioc/DependencyIdentifiers';
import LambdaDownloader from "@/utils/lambda_downloader";
import { CenterModel } from "@/models/center";

@Component({
  components: {
    EventDetail,
    EventsTableCard,
    EventTypeIcon,
    EventTypeSelectionCard,
    DateInput,
    DateRangeSelector,
  }
})
export class EventExportCompact extends Vue {
  @inject(DependencyIdentifiers.CenterService)
  private centerService!: ICenterService;
  @inject(DependencyIdentifiers.StatService)
  private statService!: IStatService;
  @inject(DependencyIdentifiers.AuthService)
  auth!: IAuthService;

  @Ref()
  form: any;

  public socialSecurityNo = "";
  private isLoading = false;
  public isDownloading = false;
  private developerView = false;
  private componentKey = 0;
  private centerList: Record<string, {data: CenterModel, isDownloading: boolean}> = {};
  private centerIdListIsLoading = false;
  private availableFormats = ['csv', 'xlsx'];
  private filter: EventExportFilter = {
    eventTypes: [],
    eventStatuses: [EventStatus.Approved, EventStatus.Draft],
    from: '',
    until: '',
    fields: ['auto'],
    socialSecurityNo: '',
  };

  private get statusMap() {
    return ["draft", "pending", "approved", "rejected"]
      .map((status) => ({
        value: status,
        text: this.$t(`event.status.${status}`) as string
      }));
  }

  async mounted() {
    this.isLoading = true;
    if (authStore.exportLock === 'pharmacy' || authStore.exportLock === 'developer') {
      this.centerIdListIsLoading = false;
      this.developerView = true;
    } else {
      const [items] = (await this.centerService.getMany(1, 100));
      const itemsRaw = items.map((data) => ([data.$id, {data, isDownloading: false }]));
      this.centerList = Object.fromEntries(itemsRaw);
      this.developerView = false;
    }
    this.isLoading = false;
  }

  public get isPatient(): boolean {
    return authStore.isPatient;
  }

  get formConfig() {
    return {
      socialSecurityNo: {
        label: this.$t('patient.fields.socialSecurityNo') + '*',
        rules: [
          (v: string) =>
            (v.replace(/^[d]/, "").length === 0 || v.replace(/^[d]/, "").length === 9) || this.$t('validator.invalidValue')
        ]
      },
    }
  }

  public onEventTypeSelectionChange(value: EventType[]): void {
    this.filter.eventTypes = value.length === 0 ? null : value;
  }

  public onStatusFilterChange(value: string[]): void {
    this.filter.eventStatuses = value as EventStatus[];
  }

  public onFieldFilterChange(value: string[]): void {
    this.filter.fields = value;
  }

  public onDateRangeChanged(from: string, until: string): void {
    this.filter.from = from;
    this.filter.until = until;
  }

  public onSocialSecurityNoChanged(no: string): void {
    this.filter.socialSecurityNo = no;
  }

  public isFormValid(): boolean {
    if (this.form) {
      return this.form.validate() && this.socialSecurityNo.length !== 0;
    }
    return false;
  }

  public async onExport(format: string, id: string) {
    this.centerList[id].isDownloading = true;

    try {
      const data = await this.statService.getExport(-1, -1, {...this.filter }, format, id);
      const blob = await LambdaDownloader.dataURItoBlob(data);
      LambdaDownloader.downloadHack(blob, `Hemonaplo - ${this.centerList[id].data.name}.${format}`);
    } catch (e) {
      alert('Error');
    } finally {
      this.centerList[id].isDownloading = false;
    }
  }

  public async onExportBySoc(format: string, soc: string) {
    if(!this.form.validate() || soc.length === 0) {
      return
    }
    this.isDownloading = true;
    try {
      const data = await this.statService.getExport(-1, -1, {...this.filter }, format);
      const blob = await LambdaDownloader.dataURItoBlob(data);
      LambdaDownloader.downloadHack(blob, `Hemonaplo - ${soc}.${format}`);
    } catch (e) {
      alert('Error');
    } finally {
      this.isDownloading = false;
    }
  }

  public async onExportAll(format: string) {
    this.centerIdListIsLoading = true;

    try {
      const data = await this.statService.getExport(-1, -1, {...this.filter }, format);
      const blob = await LambdaDownloader.dataURItoBlob(data);
      LambdaDownloader.downloadHack(blob, `Hemonaplo.${format}`);
    } catch (e) {
      alert('Error');
    } finally {
      this.centerIdListIsLoading = false;
    }
  }

  public async onReset() {
    this.$router.go(0);
  }
}

export default EventExportCompact;
